import { render } from "./ManagerCustomers.vue?vue&type=template&id=4419d4b6&scoped=true"
import script from "./ManagerCustomers.vue?vue&type=script&lang=js"
export * from "./ManagerCustomers.vue?vue&type=script&lang=js"

import "./ManagerCustomers.vue?vue&type=style&index=0&id=4419d4b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4419d4b6"]])

export default __exports__